module.exports = __webpack_public_path__ + "img/imgmaoxzt-4.26a4f273.png";